/**
 * Mirrors `WorkflowKinds.ExplicitDistribution` in the contracts package.
 * Distribution for these kinds is an explicit queue list; routing rules
 * must not target them. Keep this set in lockstep with the C# registry.
 */
export const EXPLICIT_DISTRIBUTION_KINDS: ReadonlySet<string> = new Set([
    "ad-hoc",
    "child-thread",
    "follow-up",
]);

export function isRuleRoutableKind(kind: string): boolean {
    return !EXPLICIT_DISTRIBUTION_KINDS.has(kind);
}
